import axios from "axios";

const CreateFarm = async (payload) => {
    const timestamp = Math.floor(Date.now() / 1000);
    payload.appFarmId = "FD" + timestamp;

    const token = JSON.parse(localStorage.getItem("authentication"));

    const config = {
        headers: { Authorization: `Bearer ${token}` },
    };

    try {
        const { data } = await axios.post(
            `${process.env.REACT_APP_BACKEND_API}/api/land/CreateFarm`,
            payload,
            config
        );
        return { status: 200, payload: data };
    } catch (error) {
        console.error("CreateFarm error:", error);

        const status = error?.response?.status || 500;
        return { status, payload: null };
    }
};

export default CreateFarm;
